<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '580px' }" styleClass="intake-result-dialog">
  <div class="error-state">
    <img src="assets/images/error-illustration.png" alt="" style="height: 80px;" />
    <h2 class="error-title">We Couldn't Submit Your Request</h2>
    <p class="error-copy">Something went wrong while submitting your property request.</p>
    <p class="error-copy">
      Your information has not been received by our team. Please try again in a few moments.
    </p>
    <div class="error-actions">
      <button pButton type="button" label="Contact Support" (click)="contactSupport.emit()"></button>
      <button pButton type="button" label="Try Again" class="try-again-btn" [loading]="isSaving()"
        (click)="retry.emit()"></button>
    </div>
  </div>
</p-dialog>
